var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAA520",
    d: "M1.923 12.341a1.636 1.636 0 0 1 0-2.682 1.636 1.636 0 0 0 .545-2.036A1.636 1.636 0 0 1 3.81 5.3 1.636 1.636 0 0 0 5.3 3.81a1.636 1.636 0 0 1 2.323-1.342c.72.338 1.58.108 2.035-.545a1.636 1.636 0 0 1 2.684 0 1.636 1.636 0 0 0 2.035.545A1.636 1.636 0 0 1 16.7 3.81a1.636 1.636 0 0 0 1.49 1.49 1.636 1.636 0 0 1 1.342 2.323c-.338.72-.108 1.58.545 2.035a1.636 1.636 0 0 1 0 2.684 1.636 1.636 0 0 0-.545 2.035A1.636 1.636 0 0 1 18.19 16.7a1.636 1.636 0 0 0-1.49 1.49 1.636 1.636 0 0 1-2.323 1.342 1.636 1.636 0 0 0-2.036.545 1.636 1.636 0 0 1-2.683 0 1.636 1.636 0 0 0-2.035-.545A1.636 1.636 0 0 1 5.3 18.19a1.636 1.636 0 0 0-1.49-1.49 1.636 1.636 0 0 1-1.342-2.323c.338-.72.108-1.58-.545-2.036Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.192 4.747 1.762 3.6c.027.063.09.108.161.117l3.945.575c.17.028.241.244.116.36l-2.853 2.8c-.054.044-.072.117-.063.188l.67 3.96c.028.171-.151.306-.303.226L11.094 14.7a.193.193 0 0 0-.197 0l-3.534 1.873c-.152.08-.33-.055-.304-.225l.671-3.96a.215.215 0 0 0-.062-.19L4.823 9.4a.212.212 0 0 1 .117-.36l3.944-.576a.216.216 0 0 0 .161-.118l1.762-3.6a.218.218 0 0 1 .385 0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.ff538316.svg";
export { ForwardRef as ReactComponent };